import { type FC } from 'react'

import {
  FreeformTextareaEditor,
  type FreeformTextareaProps
} from '../FreeformTextareaEditor/FreeformTextareaEditor'

export const BashEditor: FC<FreeformTextareaProps> = ({ ...props }) => (
  <FreeformTextareaEditor {...props} language="shell" />
)
